import { guestLinkEmailsSchema, MAX_GUEST_LINK_EMAILS_BATCH, } from '@lucidlink/dto/validation';
import { remapZodErrors } from '@lucidlink/uicore';
export const guestLinkEmailValidation = (values) => {
    const result = guestLinkEmailsSchema.safeParse(values);
    return {
        isValid: result.success,
        errors: result.success ? [] : remapZodErrors(result.error.issues),
    };
};
export const areGuestLinkEmailsValid = (values) => guestLinkEmailsSchema.safeParse(values).success;
export const guestLinkEmailsCountValidation = (values) => {
    if (values.length > MAX_GUEST_LINK_EMAILS_BATCH) {
        const errors = [];
        for (let index = MAX_GUEST_LINK_EMAILS_BATCH; index < values.length; index++) {
            errors.push({
                code: 'guestLink.emails.maxLength',
                path: [index.toString()],
                message: '',
            });
        }
        return {
            isValid: false,
            errors,
        };
    }
    else {
        return {
            isValid: true,
            errors: [],
        };
    }
};
